import * as React from 'react';
import { withFormik, FormikProps } from 'formik';
import * as Yup from 'yup';
import { withTranslation } from 'react-i18next';
import {Row, Col, Form, Card } from 'react-bootstrap';
import "react-bootstrap-typeahead/css/Typeahead.css";
import { TenantData, StaffMember, Room } from '../../../../store/models/domain'
import { ro } from 'date-fns/locale';
import { join } from 'lodash';

export interface FormValues {
    emailsList: string[]
    selectedEmails?: string
}

interface OtherProps{
    tenant: TenantData
    room?: Room,
    comment?: string
    submitLabel: string
    cancelLabel: string
    onCancel: (value?: any) => void
    cantCancel: boolean
    t: any
}

const EmailRecipientForm = (props: FormikProps<FormValues> & OtherProps) => {
    const {

        // Formik HOC props
        values,
        tenant,
        touched,
        errors,
        isSubmitting,
        handleSubmit,
        getFieldProps,
        setFieldValue,

        // Form props
        submitLabel,
        cancelLabel,
        onCancel,        
        cantCancel,
        room,
        comment,

        // Translate props
        t,
    } = props;

    
    const supervisors: StaffMember[]  = React.useMemo(() => [            
            ...(tenant.supervisors || []),
            ...(tenant.staffMembers || [])
                .filter((r: StaffMember) => !!r.email && !r.isArchived &&
                            !(tenant.supervisors || []).some((s: StaffMember) => s.email?.toLowerCase() === r.email?.toLowerCase()))            
        ].filter((r: StaffMember) => !r.disableNotifications && !r.isArchived)
        , [tenant]);

    const supervisorOptions = (supervisors || [])
        .map((r: StaffMember) => (
            <Form.Check type="checkbox" id={"su_" + r.id} key={r.id}
                label={(<div className='d-flex justify-content-between align-items-center'><div>{r.email}</div><div style={{flexGrow: 1}}>&nbsp;</div><div className='pl-1 pr-1 rounded' style={{backgroundColor: 'lightgray'}}>{t(r.role + '_Role')}</div></div>)} 
                className={'d-flex form-control pl-4'}
                checked={(values.emailsList || []).includes(r.email)}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.checked) {
                        setFieldValue("emailsList", (values.emailsList || []).filter((email: string) => email !== r.email).concat(r.email));
                    } else {
                        setFieldValue("emailsList", (values.emailsList || []).filter((email: string) => email !== r.email));
                    }
                }}
                />
    ));

    React.useEffect(() => {
        setFieldValue("emailsList", (supervisors || []).map((r: StaffMember) => r.email));
    }, [supervisors]);

    return (
        <Row className="justify-content-md-center">
            <Col sm={12} md={9}>               
                <Form onSubmit={(e) => { handleSubmit(e as React.FormEvent<HTMLFormElement>) }} className="p-1">

                    <Form.Group>
                        <Card className='d-flex flex-column align-items-start p-2 border rounded' style={{backgroundColor: 'lightgray'}}>
                            <Form.Label>{`Room: ${room?.roomNumber}`}</Form.Label>
                            <Form.Label>{`Comment: ${comment}`}</Form.Label>
                        </Card>
                    </Form.Group>

                    <Form.Group>
                        {supervisorOptions}
                    </Form.Group>

                    {/* Mimik sweetalert2 buttons */}
                    <div className="swal2-actions" style={{'fontSize': '16px'}}>
                        <button className="swal2-confirm swal2-styled" type="submit">{submitLabel}</button>
                        <button className="swal2-cancel swal2-styled" type="button" onClick={() => { onCancel() }} disabled={isSubmitting || cantCancel}>{cancelLabel}</button>
                    </div>                    
                </Form>
            </Col>           
        </Row>
    );
};

const validate = withFormik<any, FormValues>({
    mapPropsToValues: props => ({
        emailsList: [],
        selectedEmails: "",
    }),

    validationSchema: (props: any) => {
        return Yup.object().shape({
        })
    },

    handleSubmit: (values, { props }) => {
        debugger;
        props.onSave({
            emailsList: values.emailsList,
            selectedEmails: (values.emailsList || []).join(";") 
        });
    },
});

const translate = withTranslation();
export default translate(validate(EmailRecipientForm));
